import { useEffect, useState } from "react";
import { getNutriContext } from "../nutrisalud/NutriCaptureControls";
import { contextDefaults, contextErrorMessage } from "../utils/convocatoriaContext";

export default function useAnticonContext(capture) {
  const [context, setContext] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    setContext(null);
    setError("");
    if (capture.contextReady && capture.qa.enabled) {
      getNutriContext(capture.convocatoriaId).then(value => {
        if (!cancelled) setContext(value);
      }).catch(error => { if (!cancelled) setError(contextErrorMessage(error)); });
    }
    return () => { cancelled = true; };
  }, [capture.convocatoriaId, capture.contextReady, capture.qa.enabled]);
  const current = context && String(context.id) === String(capture.convocatoriaId) ? context : null;
  return { context: current, error, defaults: contextDefaults(current) };
}
